import { useState } from "react";

const messages = [
  "Learn React ⚛️",
  "Apply for jobs 💼",
  "Invest your new income 🤑",
];

export default function App() {
  return (
    <div>
      <Steps />
      <StepMessage step={1}>
        <p>Pass in content</p>
        <p>✌</p>
      </StepMessage>
      <StepMessage step={2}>
        <p>Read children prop</p>
        <p>👏</p>
      </StepMessage>
      {/* <Steps /> */}
    </div>
  );
}

function Steps() {
  const [step, setStep] = useState(1);
  const [isOpen, setIsOpen] = useState(true);

  //Bad practice
  //const [test] = useState({ name: "Cameron" });

  //Good practice
  //const [test, setTest] = useState({ name: "Cameron" });

  // function handlePrevious() {
  //   if (step > 1) setStep(step - 1);
  // }
  function handlePrevious() {
    if (step > 1) setStep((s) => s - 1);
  }

  // function handleNext() {
  //   if (step < 3) setStep(step + 1);
  function handleNext() {
    if (step < 3) {
      setStep((s) => s + 1);
      //setStep((s) => s + 1);
    }

    //Bad practice
    //test.name = "Howze!";

    //Good practice
    //setTest({ name: "Dude!" });
  }

  return (
    <div>
      {/* <button className="close" onClick={() => setIsOpen(!isOpen)}> */}
      <button className="close" onClick={() => setIsOpen((is) => !is)}>
        &times;
      </button>

      {isOpen && (
        <div className="steps">
          <div className="numbers">
            <div className={step >= 1 ? "active" : ""}>1</div>
            <div className={step >= 2 ? "active" : ""}>2</div>
            <div className={step >= 3 ? "active" : ""}>3</div>
          </div>

          <StepMessage step={step}>
            {messages[step - 1]}{" "}
            <div className="buttons">
              {" "}
              <Button
                bgColor="e7e7e7"
                textColor="333"
                onClick={() => alert(`Learn how to $(messages[step - 1])`)}
              >
                Learn how
              </Button>
            </div>
          </StepMessage>

          <div className="buttons">
            <Button
              bgColor={"#7950f2"}
              textColor={"#fff"}
              onClick={handlePrevious}
            >
              {/* chrildren prop */}
              <span>👈</span>Previous
            </Button>
            <Button bgColor={"#7950f2"} textColor={"#fff"} onClick={handleNext}>
              {/* chrildren prop */}
              Next <span>👉</span>{" "}
            </Button>
          </div>
        </div>
      )}
    </div>
  );
}

function StepMessage({ step, children }) {
  return (
    <div className="message">
      <h3>Step {step}</h3>
      {children}
    </div>
  );
}

function Button({ textColor, bgColor, onClick, children }) {
  return (
    <button
      style={{ backgroundColor: bgColor, color: textColor }}
      onClick={onClick}
    >
      {children}
    </button>
  );
}
